var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-dropdown',{attrs:{"oneLine":true,"options":this.options,"value":this.sort,"name":"searchSort","placeholder":"Sortera efter: "},on:{"changed":_vm.updateSort,"inputChange":_vm.updateSort}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39d4f83c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Search/SearchSort.vue
// module id = 712
// module chunks = 1